export default "__VITE_ASSET__BndSZIki__"